import { render, staticRenderFns } from "./ListItemStops.vue?vue&type=template&id=665a183a"
import script from "./ListItemStops.vue?vue&type=script&lang=js"
export * from "./ListItemStops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports